import { STRIPE_PRODUCTS } from '../config/stripeConfig';

// Build PRICES map from central config
export const PRICES = Object.fromEntries(
  Object.entries(STRIPE_PRODUCTS).map(([key, val]) => [key, val.priceId])
);

export async function startCheckout(membership, user, profile) {
  const product = STRIPE_PRODUCTS[membership];
  if (!product) { alert('Plan no disponible'); return; }

  const res = await fetch('/api/create-checkout', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      membership,
      userId: user?.id || '',
      userEmail: user?.email || profile?.email || '',
    }),
  });

  const data = await res.json();
  if (data.url) {
    window.location.href = data.url;
  } else {
    alert('Error: ' + (data.error || 'No se pudo crear la sesion de pago'));
  }
}
